/**
 * 会员营销 - 会员分群
 */

import { get, post, postJson, deleteApi, imagePost } from '../axios'

// const RESOURCE_BASE_PATH = '/jd-yusms/memberCrowd'
const RESOURCE_BASE_PATH = '/memberCrowd/'


export const getSysConfigByKe = p => get(`/common/getSysConfigByKey`, p);
// 查询会员人群
export const queryMemberCrowd = p => get(`${RESOURCE_BASE_PATH}`, p);
// 查询详情
export const queryMemberCrowdDetail = p => get(`${RESOURCE_BASE_PATH}detail`, p);
// 查询会员人群分类
export const queryCrowdClassify = p => get(`${RESOURCE_BASE_PATH}classify/${p}`);

// 新增/编辑人群分类
export const updateCrowdClassify = p => postJson(`${RESOURCE_BASE_PATH}classify`, p);

// 删除人群分类
export const delCrowdClassify = p => deleteApi(`${RESOURCE_BASE_PATH}classify/${p}`);

// 新增/编辑会员人群
export const addMemberCrowd = p => postJson(`${RESOURCE_BASE_PATH}`, p);

// 查询商家创建的人群总数
export const createdCount = p => get(`${RESOURCE_BASE_PATH}created-count`, p);

// 人群实例化
export const crowdInstance = p => postJson(`${RESOURCE_BASE_PATH}crowd-instance`, p);

// 人群包状态更新
export const packStatus = p => postJson(`${RESOURCE_BASE_PATH}pack-status`, p);
// 人群包状态更新

// 删除人群
export const delMemberCrowd = (precisionCrowdStrategyId, strategyId) => deleteApi(`${RESOURCE_BASE_PATH}${precisionCrowdStrategyId}`, { strategyId });

// 同步数坊人群
export const isvUsrPack = p => postJson(`${RESOURCE_BASE_PATH}isv-user-pack`, p);

// 人群分析
export const crowdAnalysis = p => postJson(`${RESOURCE_BASE_PATH}crowd-analysis`, p);
// 上传人群-手动输入
export const uploadManual = p => postJson(`${RESOURCE_BASE_PATH}upload-manual`, p);

// 上传人群-文件导入
export const uploadImport = p => imagePost(`${RESOURCE_BASE_PATH}upload-import`, p);

// 将人群同步至DMP
export const synDmp = p => postJson(`${RESOURCE_BASE_PATH}syn-dmp`, p);

// 获取官方推荐列表 
export const getOfficialRecommend = p => get(`${RESOURCE_BASE_PATH}official/recommend`, p)

// 获取官方推荐列表 memberCrowd/sys
export const getOfficialmemberCrowd = p => get(`memberCrowd/sys`, p)

// 官方推荐人群立即营销
export const officialMarket = p => postJson(`${RESOURCE_BASE_PATH}official/marketing`, p)

// 更新获取人群状态
export const updateIsGetCrowd = p => postJson(`memberCrowd/updateIsGetCrowd`, p)
// 获取用户菜单列表
export const getSeller = p => get(`/seller/current`, p);

// 获取人群分类树
export const getTreeData = p => get(`/memberCrowd/classify/tree`, p);

// 拖拽分类
export const changeClassify = p => postJson(`/memberCrowd/classify/change`, p);

// 生成云起人群
export const yunQiCrowdAdd = p => postJson(`/yunQiCrowd/add`, p)

// 云起人群分页查询接口
export const getYyunQiCrowd = p => get(`/yunQiCrowd/page`, p);

// get
export const buildHd = p => get(`/yunQiCrowd/buildHd`, p);

// 查询官方人群 
export const queryOfficialCrowd = p => get(`${RESOURCE_BASE_PATH}official`, p);

// 同步官方人群 
export const syncOfficialCrowd = p => postJson(`${RESOURCE_BASE_PATH}syncOfficial`, p);

// 创建sku人群 
export const createBuySkuBehavior = p => postJson(`/memberCrowd/createBuySkuBehavior`, p);